import { GET_CUSTOMERS } from './getCustomers';

export const customersApi = {
  getCustomers: GET_CUSTOMERS,
};
